module.exports = __webpack_public_path__ + "static/media/video-case-generic.0bdd775b.mp4";